import { HeaderWrapper } from 'layouts';
import type { Event } from 'models';
import { HeaderAsset, HeaderContent } from 'ui';
import { images } from 'common/utils';
import { useGetMediaSource } from 'features/media';
import { useGetEventTagsProperties } from '../hooks';

type P = { event: Event };

const PublicEventHeader = ({ event }: P) => {
  const { coverPhoto, endTime, name, startTime, status, type } = event;
  const tags = useGetEventTagsProperties({ endTime, eventType: type, startTime, status });
  const getMediaSource = useGetMediaSource();

  return (
    <HeaderWrapper
      left={
        <HeaderAsset
          image={{
            alt: 'Event cover photo',
            src: coverPhoto ? getMediaSource({ id: coverPhoto }) : images.default.eventCoverPhoto,
          }}
        />
      }
      right={<HeaderContent tags={tags} timeInfo={{ dateFrom: startTime, dateTo: endTime }} title={name} />}
    />
  );
};

export default PublicEventHeader;
